import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appHide]'
})
export class HideDirective implements OnChanges {
  @Input() appHide: boolean;

  constructor(private el: ElementRef) {
  }

  ngOnChanges(changes: SimpleChanges) {
    const change = changes['appHide'];
    if (change) {
      change.currentValue ? this.hide() : this.show();
    }
  }

  private hide() {
    this.el.nativeElement.style.display = 'none';
  }

  private show() {
    this.el.nativeElement.style.display = '';
  }

}
